import {observer} from "mobx-react-lite";
import {useRouterStore} from "mobx-state-router";
import {FormattedMessage, useIntl} from "react-intl";
import React, {useContext} from "react";
import {StateContext} from "../../../../../App";
import {Button, Col, FormGroup, Label, Row} from "reactstrap";
import {TimeZoneSelect} from "../../../../elements/timeZone/TimeZoneSelect";
import {types} from "mobx-state-tree";

export const TimeZoneModalState = types.model("TimeZoneModalState", {
  selectedTimezone: types.optional(types.string, "UTC")
}).actions(self => ({
  updateTimeZone(timezone) {
    self.selectedTimezone = timezone;
  },
}));

export const TimeZoneModal = observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const intl = useIntl();
  const stateContext = useContext(StateContext);

  return (
    <>
      <Row className="p-1">
        <Label sm={2} className="text-sm-right">
          <FormattedMessage
            id="data.exports.settings.timezone.defaultMessage"
            defaultMessage="Timezone"
          />
        </Label>
        <Col sm={10}>
          <TimeZoneSelect
            className="react-select-container"
            classNamePrefix="react-select"
            value={store?.selectedTimezone}
            onChange={(data) => store?.updateTimeZone(data)}
            overrideProps={{
              options: currentState?.getTimeZoneOptions(),
              defaultValue: currentState?.getDefaultTimeZone(),
              menuPortalTarget: document.body,
              menuPosition: "fixed",
              styles: { menuPortal: (base) => ({ ...base, zIndex: 99999 }) },
            }}
          />
        </Col>
      </Row>
      <Row className="p-1">
        <Col>
          <i>
            Applied to all properties in export service (time, schedule, filter) as well as code creation date,
            last modified date and all scan times and dates
          </i>
        </Col>
      </Row>
      <Row className="p-1">
        <Col>
          <FormGroup row>
            <Col sm={2}>
              <Button
                className="btn-outline-secondary mr-1"
                color="secondary"
                id="cancel-btn"
                onClick={() => {
                  currentState.modalStore.toggle();
                  store?.updateTimeZone(currentState?.timezone);
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/>
              </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button
                outline
                color="primary"
                onClick={() => {
                  currentState?.updateTimeZone(store?.selectedTimezone);
                  currentState.modalStore.toggle();
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/>
              </Button>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
});

